// Xem nhanh + ký duyệt nhanh (V2) — port từ ModalFastView, dùng endpoint tk_step.
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Spinner from "../../component/Spinner";
import ReactImageLightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { confirmAlert } from "react-confirm-alert";
import { trinhKyApi } from "../services/trinhKyApi";
import { ACTION, ROUTE } from "../constants/trinhKy";

export default function ModalFastViewV2({ detail, idstep, onSuccess }) {
  const { user } = useSelector((state) => state.auth);
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleApprove = (stepId) => {
    if (buttonLoading) return;
    setButtonLoading(true);
    trinhKyApi
      .stepAction(user.config, stepId, { action: ACTION.APPROVE, note_comment: "" })
      .then((res) => {
        if (res.data.status === "success") {
          setButtonLoading(false);
          setShow(false);
          if (onSuccess) onSuccess();
          confirmAlert({
            title: "Thông báo",
            message: "Thao tác thành công",
            buttons: [{ label: "OK", onClick: () => { if (!onSuccess) history.push(ROUTE.list); } }],
          });
        } else {
          setButtonLoading(false);
          confirmAlert({ title: "Lỗi", message: res.data.message, buttons: [{ label: "OK" }] });
        }
      })
      .catch((err) => {
        console.log(err);
        setButtonLoading(false);
        confirmAlert({
          title: "Lỗi",
          message: err?.response?.data?.message || "Không thể ký duyệt. Vui lòng thử lại.",
          buttons: [{ label: "OK" }],
        });
      });
  };

  return (
    <div className="search-box-modal height32">
      <button className="btn btn-sm btn-info text-white w-100" type="button" onClick={() => setShow(true)}>
        <span className="fas fa-fighter-jet"></span>Xem nhanh
      </button>
      <Modal show={show} onHide={() => setShow(false)} animation={true} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{detail.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {detail && detail.file_preview && Array.isArray(detail.file_preview) &&
            detail.file_preview.map((url, k) => (
              <img src={url} className="img" alt="" key={k} onClick={() => { setPhotoIndex(k); setIsOpen(true); }} />
            ))}
          {isOpen && (
            <ReactImageLightbox
              mainSrc={detail.file_preview[photoIndex]}
              nextSrc={detail.file_preview[(photoIndex + 1) % detail.file_preview.length]}
              prevSrc={detail.file_preview[(photoIndex + detail.file_preview.length - 1) % detail.file_preview.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() => setPhotoIndex((photoIndex + detail.file_preview.length - 1) % detail.file_preview.length)}
              onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % detail.file_preview.length)}
            />
          )}
          <div className="w-100 p-2 d-flex justify-content-center group-check-action">
            {idstep && (
              <button className="btn btn-sm btn-success" type="button" onClick={() => handleApprove(idstep)} disabled={buttonLoading}>
                {buttonLoading ? <Spinner /> : <><i className="fas fa-check"></i> Ký duyệt</>}
              </button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
